import locale from '../locale';
export * from '../locale';
export default locale;